import {AnyAction} from "redux";

export const SET_PLAN_ITEM = "SET_PLAN_ITEM";

const initialState = {
    planItem: null,
}

export const planItemReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case SET_PLAN_ITEM: return { ...state,
            planItem: action.payload
        }
        default: return state
    }
}